import paymentAPI from 'src/pages/deprecated/payment/api';
import {
  ReactivationDetails,
  CancelReactivatePayload,
} from './reactivation.types';

export * from './reactivation.types';

/**
 * Fetch the reactivation preview summary.
 *
 * @param campaignCode - Optional campaign code to pass to the API.
 *   This is non-blocking: if omitted or the server ignores it, the call
 *   succeeds as before.
 */
export const fetchReactivationDetails = async (
  campaignCode?: string | null
): Promise<ReactivationDetails> => {
  const params: Record<string, string> = {};
  if (campaignCode) {
    params.campaignCode = campaignCode;
  }
  const response = await paymentAPI.get(
    'v1/user/reactivation-preview-summary',
    { params }
  );
  return response.data;
};

export const reactivateSubscription = async (
  payload: CancelReactivatePayload
): Promise<any> => {
  if (!payload || !payload?.email || !payload?.userId) {
    throw new Error('Invalid payload for reactivate subscription');
  }

  // NOTE: campaignCode is temporarily omitted from the payload at service level.
  // This can be added back based on confirmation whether it is needed.
  const { campaignCode, ...body } = payload;

  const response = await paymentAPI.post(
    'stripe/customer/cancel/reactivate',
    body
  );
  return response.data;
};
